import './style.scss';
import './pagination.scss';
import React from 'react';
import { isServer } from '@sitecore-jss/sitecore-jss';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Pagination, Navigation } from 'swiper';
import Item from '../Shared/Item';
const ItemsCarousel = (props) => {
  const { language, items, setPrevDisabled, setNextDisabled, swiperRef } = props;
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="custom-pagination-cardlisting ' + className + '"></span>';
    },
  };
  const onSwap = (pagesAmount, isFirst, isLast) => {
    setPrevDisabled(isFirst);
    setNextDisabled(isLast);
  };

  const handleSwap = (swiper) => {
    if (!onSwap) return;
    if (swiper?.pagination?.bullets?.length) {
      onSwap(swiper.pagination.bullets.length, swiper.isBeginning, swiper.isEnd);
    } else {
      onSwap(1, true, true);
    }
  };

  return (
    !isServer() && (
      <Swiper
        className="crgv__swiper"
        modules={[Pagination, Navigation]}
        pagination={pagination}
        dir={language === 'en' ? 'ltr' : 'rtl'}
        spaceBetween={24}
        slidesPerView={3}
        slidesPerGroup={1}
        onSlideChange={handleSwap}
        onPaginationRender={handleSwap}
        ref={swiperRef}
        breakpoints={{
          375: {
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 16,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 16,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
            slidesPerGroup: 1,
          },
        }}
      >
        {items?.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <Item item={item} index={index} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  );
};

export default ItemsCarousel;
